import { render, staticRenderFns } from "./TransportationProfileComponent.vue?vue&type=template&id=85ae36e6&scoped=true"
import script from "./TransportationProfileComponent.vue?vue&type=script&lang=js"
export * from "./TransportationProfileComponent.vue?vue&type=script&lang=js"
import style0 from "./TransportationProfileComponent.vue?vue&type=style&index=0&id=85ae36e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ae36e6",
  null
  
)

export default component.exports